import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { SectionTitle, Spinner, EmptyState } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { useIsMobile } from "@/hooks/useMediaQuery";

export default function Wishlist() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!user) { setItems([]); return; }
    api("/wishlist").then(setItems).catch(() => setItems([]));
  }, [user]);

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "24px 16px 40px" : "40px 24px 56px" }}>
      <SectionTitle eyebrow="Saved" title="Wishlist" />
      {!user ? (
        <EmptyState title="Sign in to view your wishlist" action={<Link to="/login" className="btn-primary" style={{ textDecoration: "none" }}>Sign In</Link>} />
      ) : items === null ? <Spinner /> : items.length === 0 ? (
        <EmptyState title="No favourites yet" message="Tap the heart on any piece to save it here." action={<Link to="/" className="btn-primary" style={{ textDecoration: "none" }}>Browse Shop</Link>} />
      ) : (
        <div className="product-grid">{items.map((p) => <ProductCard key={p.id} product={p} inWishlist onWishlistChange={(id, on) => !on && setItems((prev) => prev.filter((x) => x.id !== id))} />)}</div>
      )}
    </div>
  );
}
